import { connectInfiniteHits } from 'react-instantsearch-dom';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

import RecipesJsonLd from '../../SEO/RecipesJsonLd';

const InfiniteHits = ({
  hits,
  hasMore,
  refineNext,
  HitComponent,
  resultState,
  firstsDailyRecipes,
  localFiles,
}) => {
  const loader = useRef(null);
  const [isSetUp, setIsSetUp] = useState(false);
  const [displayHits, setDisplayedHits] = useState(
    resultState && resultState.hits && firstsDailyRecipes
      ? [...firstsDailyRecipes, ...resultState.hits.filter(
        (hit) => !firstsDailyRecipes.map((hitOfFirstsDailyRecipes) => hitOfFirstsDailyRecipes.id).includes(hit.id),
      )]
      : [],
  );

  const handleObserver = (entities) => {
    if (entities[0].isIntersecting && hasMore) {
      // loader.current.click()
    }
  };

  useEffect(() => {
    const firstsDailyRecipesIds = firstsDailyRecipes.map((hit) => hit.id);

    if (hits.length > 0) {
      setDisplayedHits([...firstsDailyRecipes, ...hits.filter((hit) => !firstsDailyRecipesIds.includes(hit.id))]);
    }

    if (loader.current && !isSetUp && displayHits.length > 0 && hasMore) {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      };

      const observer = new IntersectionObserver(handleObserver, options);
      observer.observe(loader.current);
      setIsSetUp(true);
    }
  }, [hits, hasMore, resultState, firstsDailyRecipes]);

  return (
    <HitsContainer>
      <Helmet>
        {displayHits[0] && (
        <meta
          property="og:image"
          content={displayHits[0].web_cover_thumbnail}
        />
        )}
      </Helmet>
      <RecipesJsonLd
        recipesListElements={
        displayHits.slice(0, 20).map((hit, index) => ({
          position: index + 1,
          imageUrl: hit.web_cover_thumbnail,
          url: hit.absolute_url,
          recipeTitle: hit.title,
        }))
        }
      />
      <ul>
        {displayHits.map((hit) => (
          <li key={hit.objectID}>
            <HitComponent hit={hit} key={hit.objectID} localFiles={localFiles} />
          </li>
        ))}
      </ul>

      {
        !hasMore && (
          <p>De nouvelles recettes arrivent bientôt !</p>)
          }
      <button type="button" disabled={!hasMore} onClick={refineNext} ref={loader} style={{ display: hasMore ? 'block' : 'none' }}>
        Voir plus de recette !
      </button>

    </HitsContainer>
  );
};

const HitsContainer = styled.div`
  text-align: center;

  ul {
    list-style: none;
    margin-left: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px 30px;
    margin-bottom: 20px;
    padding-left: 0px;
  }

  li {
    box-shadow: 3px 0 30px 0 rgb(0 0 0 / 16%);
    overflow: hidden;
    margin-bottom: 1em;
    background: white;
    border-radius: 10px;
    width: 190px;
    height: 190px;
    flex-shrink: 0;
    flex-grow: 0;

  }
`;

const ScrollInfiniteHits = connectInfiniteHits(InfiniteHits);

export default ScrollInfiniteHits;
